import { render, staticRenderFns } from "./approvalProjects.vue?vue&type=template&id=9dd1ecb0&"
import script from "./approvalProjects.vue?vue&type=script&lang=ts&"
export * from "./approvalProjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports